import { Injectable, Signal, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { TReducerState } from '../../app.config';
import { userActions } from '../../state/user/user.actions';
import { TItemsComponentPageConfiguration } from '../../state/user/user.interface';
import { TItemView, TItemsComponentItemViewConfiguration } from './items-filter-card/items-filter-card.interface';

@Injectable({ providedIn: 'root' })
export class ItemsViewPreferenceService {
  private readonly globalStore: Store<TReducerState> = inject(Store);
  private readonly user = this.globalStore.selectSignal((state: TReducerState) => state.user.user);

  public readonly itemView: Signal<TItemView> = computed(() => {
    const configurations: TItemsComponentPageConfiguration[] = this.user()?.pageConfiguration?.ItemsComponent ?? [];
    const itemViewConfiguration = configurations.find(
      (configuration): configuration is TItemsComponentItemViewConfiguration => configuration.name === 'itemView',
    );

    return itemViewConfiguration?.value ?? 'list';
  });

  public setItemView(itemView: TItemView): void {
    const componentConfigurations: TItemsComponentPageConfiguration[] =
      cloneDeep(this.user()?.pageConfiguration?.ItemsComponent)?.filter(
        (configuration) => configuration.name !== 'itemView',
      ) ?? [];

    this.globalStore.dispatch(
      userActions.updateUserConfigurations({
        omitSuccessToast: true,
        pageConfiguration: {
          ...(this.user()?.pageConfiguration ?? {}),
          ItemsComponent: [...componentConfigurations, { name: 'itemView', value: itemView }],
        },
      }),
    );
  }
}
